
import React, { createContext, useContext, useState, useEffect } from 'react';

import { useAuthContext } from '../components/AuthProvider';

const BusinessContext = createContext();

export const useBusinessContext = () => {
  const context = useContext(BusinessContext);
  if (!context) {
    throw new Error('useBusinessContext must be used within a BusinessProvider');
  }
  return context;
};

export const BusinessProvider = ({ children }) => {
  // Initialize state from localStorage
  const [businessId, setBusinessId] = useState(localStorage.getItem('businessId') || null);
  const [businessName, setBusinessName] = useState(localStorage.getItem('businessName') || '');
  const [logo, setBusinessLogo] = useState(localStorage.getItem('logo') || '');
  const [loading, setLoading] = useState(true);
  const { company, loginUser } = useAuthContext();

  const setBusiness = (id, name, logo) => {
    console.log('Setting business:', { id, name, logo });
    setBusinessId(id);
    setBusinessName(name || '');
    setBusinessLogo(logo || '');
    if (id) {
      localStorage.setItem('businessId', id);
    } else {
      localStorage.removeItem('businessId');
    }
    if (name) {
      localStorage.setItem('businessName', name);
    } else {
      localStorage.removeItem('businessName');
    }
    if (logo) {
      localStorage.setItem('logo', logo);
    } else {
      localStorage.removeItem('logo');
    }
  };

  const resetBusiness = () => {
    console.log('Resetting business data');
    setBusinessId(null);
    setBusinessName('');
    setBusinessLogo('');
    localStorage.removeItem('businessId');
    localStorage.removeItem('businessName');
    localStorage.removeItem('logo');
  };

  useEffect(() => {
    if (loginUser) {
      if (businessId) {
        console.log('Retaining existing business from localStorage:', { businessId, businessName, logo });
        setLoading(false);
      } else if (company) {
        console.log('Updating business from company:', company);
        setBusiness(company.id, company.name, company.logo);
        setLoading(false);
      } else {
        console.log('No company found for user, resetting business');
        resetBusiness();
        setLoading(false);
      }
    } else {
      console.log('No authenticated user, resetting business data');
      resetBusiness();
      setLoading(false);
    }
  }, [company, loginUser, businessId, businessName, logo]);

  const value = {
    businessId,
    businessName,
    logo,
    loading,
    setBusiness,
    resetBusiness,
  };

  return (
    <BusinessContext.Provider value={value}>
      {children}
    </BusinessContext.Provider>
  );
};
